
export default {
    name: 'SaveStatusIndicator',
    props: {
        status: {
            type: String,
            validator: function (value: string | null) {
                if (!value) {
                    return true
                }
                return ['saving', 'saved'].includes(value)
            },
        },
        as: {
            type: String,
            default: 'span',
        },
    },
}
